import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/legal/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const PrayerWithParentsLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0,1]);

  const renderAccordionFraud = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}BeSkeptical.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon} ${styles.highlightsIconEnlarge}`} />
                  <p className={styles.highlightsItemHeaderTitle} > BE SKEPTICAL </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                        <b>Be aware of things that sound too good to be true.</b><br/>
                        If it sounds too good to be true, it probably is - approach situations with a healthy dose of skepticism. </p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}ProvideLegalIcon.png`} className={`${styles.highlightsItemHeaderImgIcon}`} />
                  <p className={styles.highlightsItemHeaderTitle} > LEGAL CHANGES </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                        <b>Changes to power of attorneys, wills, trusts, insurance, or beneficiaries.</b><br/>
                        Make sure that the only people who have access to secure information and accounts are those whom the 
                        older adult trusts.  </p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}MoneyCrime.png`} className={`${styles.highlightsItemHeaderImgIcon} `} />
                  <p className={styles.highlightsItemHeaderTitle} > UNUSUAL CHARGES </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                        <b>Unusual bank account and credit activity.</b><br/>
                        Encourage the older adult to check their bank accounts, credit card accounts, and credit reports 
                        regularly. Look for any unauthorized withdrawals or spending, transfers between accounts, or any 
                        newly opened credit accounts. This could mean that someone has access to their personal information. </p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}FraudPhishing.png`} className={styles.highlightsItemHeaderImgEnlargeIcon} />
                  <p className={styles.highlightsItemHeaderTitle} > UNSOLICITED SALES </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                        <b>Someone wanting to sell an insurance policy or financial service.</b><br/>
                        This is not necessarily a warning sign, but if someone contacts the older adult out of the blue, you 
                        will want to ensure they do their due diligence to research the individual/company before giving access 
                        to any information.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };

  const renderAccordionScams = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}ImpersonationScam.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon} ${styles.highlightsIconEnlargeXL}`} />
                  <p className={styles.highlightsItemHeaderTitle} > IMPERSONATION SCAM </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                        <b> Government impersonation scams. </b><br/>
                        These scammers typically say they are calling from the IRS or Social Security Administration and 
                        threaten cancellation of benefits for non-payment.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}MoneyScam2.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon} ${styles.highlightsIconEnlarge}`} />
                  <p className={styles.highlightsItemHeaderTitle} > LOTTERY SCAM </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} > 
                        For these scams, the caller will inform the older adult that they have won something and to claim 
                        the prize, they have to provide their information or even submit a payment up front.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColLeft}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}FraudBlackmail.png`} className={styles.highlightsItemHeaderImgEnlargeIcon} />
                  <p className={styles.highlightsItemHeaderTitle} > TECH SUPPORT SCAM </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} > 
                        The older adult may receive a pop-up on their computer telling them that their device is not working 
                        properly and once they contact the “tech support” number, they will be asked to give payment with their 
                        personal information.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column width={6} container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}PhonecallWarning.svg`} className={`${styles.highlightsItemHeaderImgIcon} ${styles.highlightsIconShrinkMore}`} />
                  <p className={styles.highlightsItemHeaderTitle} > PHONE SCAM </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} > 
                        These scam calls may have an automated voice that asks a question and records the older adults voice 
                        saying “yes” or their name or some other identifying thing. The scammers then use this to authorize 
                        charges on their accounts. Sometimes, they will impersonate a law enforcement agency and try to convince 
                        the older adult to pay them to release a friend or family member.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColRight}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}GrandparentFraud.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon} ${styles.highlightsIconEnlarge}`} />
                  <p className={styles.highlightsItemHeaderTitle} > GRANDPARENT SCAM </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} > 
                        Someone contacts the older adult pretending to be a grandchild under some sort of financial duress. They 
                        will ask the older adult not to tell anyone to avoid getting the “grandchild” in trouble. They then request 
                        a money transfer or other access to money accounts. </p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'fraud',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Potential Warning Signs of Fraud </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionFraud()}/>)
      }
    },
    { key: 'scams',
      index: 1,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Common Scams Targeting Seniors </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionScams()}/>)
      }
    },
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}FraudAndScams1.jpeg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(PrayerWithParentsLearnMore);
